export const BROWSE_ICON = 'browseIcon';

export const ICON_LEFT = 'left';
export const ICON_RIGHT = 'right';

export const DEFAULT_LABEL = 'Browse all content';
export const TEST__LABEL = 'Browse';

export const DEFAULT_PATH = 'https://www.google.com';
export const TEST_PATH = '/browse';
